import Layout from '../../components/Layout';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { getArtistData, getUserArtworks, selectGetUser, selectUserArtworks } from '../../redux/userReducer';
import { API_URL } from '../../config/constants';
// import RadioGroup from "@material-ui/core/RadioGroup";
// import FormControlLabel from "@material-ui/core/FormControlLabel";
// import Radio from "@material-ui/core/Radio";
//import { createStyles, makeStyles } from "@material-ui/core/styles";
// import { NATIONALITIES }  from '../../config/constants';
// import Select from 'react-select';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, A11y } from 'swiper';
import { Link } from 'react-router-dom';
import { getResolvedPath, getArtworkQuery } from '../../utils/utils';

// const useStyles = makeStyles(theme =>
//     createStyles({
//       smallRadioButton: {
//         "& svg": {
//           width: "0.8em",
//           height: "0.8em",
//           color: "#E02829"
//         },
//         "& span": {
//           fontSize: ".875rem",
//         }
//       }
//     })
//   );
  
function UserProfile_Detail() {
  const { url } = useParams();
  const navigate = useNavigate();
  const user = useSelector(selectGetUser);
  const dispatch = useDispatch();
  //const classes = useStyles();

  const [firstname, setFirstName] = useState('')
  const [lastname, setLastName] = useState('')
  //const [birth, setBirth] = useState('')
  const [biography, setBiography] = useState('')
  const [education, setEducation] = useState('')
  const [exhibition, setExhibition] = useState('')
  const [publication, setPublication] = useState('')
  const [birthday, setBirthday] = useState('');
  //const [teaching, setTeaching] = useState('')
  //const [writing, setWriting] = useState('')
  //const [curating, setCurating] = useState('')
  //const [publics, setPublic] = useState('')
  //const [privates, setPrivate] = useState('')
  const [appearance, setAppearance] = useState('')
  //const [link, setLink] = useState('')
  //const [pritoken, setPriToken] = useState('')
  //const [notification, setNotification] = useState(true)
  const [photo, setPhoto] = useState(API_URL + '/uploads/default_avatar.jpg')
  const artworks = useSelector(selectUserArtworks);
  const [selectedTab, SelectTab] = useState(0);

  //const [optionsForNationalities, setOptionsForNationalities] = useState([]);
  //const [defaultNationality, setDefaultNationality] = useState();
  
  useEffect(() => {
    dispatch(getArtistData(url));
  }, [url, dispatch])

  useEffect(() => {
    if ( user && user.url === url ) {
      setFirstName(user.firstname)
      setLastName(user.lastname)
      //setBirth(user.birth)
      setBiography(user.biography)
      setEducation(user.education)
      setExhibition(user.exhibition)
      setPublication(user.publication)
      setBirthday(user.birth);
      //setTeaching(user.teaching)
      //setWriting(user.writing)
      //setCurating(user.curating)
      //setPublic(user.public)
      //setPrivate(user.private)
      setAppearance(user.appearance.trim())
      //setLink(user.link)
      //setPriToken(user.pritoken)
      //setNotification(user.notification)

      // var default_nationality;
      
      // NATIONALITIES.map((nationality) => {
      //   if ( nationality.Nationality === user.nationality ) {
      //     default_nationality = {value: nationality.Nationality, label: nationality.Nationality};
      //   }
      // })
      //setDefaultNationality(default_nationality);

      if ( user.avatar )
        setPhoto(API_URL + '/uploads/' + user.avatar)

      dispatch(getUserArtworks(user._id));
    }
  }, [user, url, dispatch])

  // useEffect(() => {
  //   var nationality_list = [];
  //   NATIONALITIES.map((nationality) => {
  //     nationality_list.push({value: nationality.Nationality, label: nationality.Nationality});
  //   })
  //   //setOptionsForNationalities(nationality_list);
  // }, []);

  const extractUrlFromString = (str) => {
    let newstringreplaced = str.replace(/https/gi, ",https");
    let newstring = newstringreplaced.split(",");
    newstring.splice(0, 1);
    return newstring;
  }

  return (
    <Layout>
      {user && user.url === url && <>
        <div className='flex flex-col w-full m-2 md:m-4 lg:m-6 px-2 sm:px-6 md:px-10 lg:px-20 xl:px-40'>
          <div className='flex flex-row w-full gap-10'>
            <div className='min-w-[75px] sm:min-w-[100px] md:min-w-[150px] lg:min-w-[200px] m-auto'>
              <img src={photo} alt="_photo_" className='w-[75px] sm:min-w-[100px] md:min-w-[150px] lg:min-w-[200px] h-[75px] sm:min-h-[100px] md:min-h-[150px] lg:min-h-[200px] rounded-full m-auto object-cover'/>
            </div>
            <div className='w-full flex flex-col'>
              <span className="text-lg lg:text-xl font-semibold text-ato-red font-millerBanner">
                {firstname} {lastname}
              </span>
              <span className="text-md lg:text-lg text-ato-black font-millerBanner mt-6">
                {birthday}
              </span>
              {/* <span className="text-md lg:text-lg text-ato-black font-millerBanner mt-6">
                {education}
              </span>
              <span className="text-md lg:text-lg text-ato-black font-millerBanner mt-6">
                {publication}
              </span> */}
            </div>
          </div>
          
          <div className="md:flex md:flex-row mt-[3rem] space-x-2 sm:space-x-4 md:space-x-5 lg:space-x-6 text-md md:text-xl lg:text-2xl xl:text-2xl border-b-2 mb-[1rem]">
            <h3 className={
              selectedTab === 0 ? "inline-block text-ato-red font-millerBanner px-2 sm:px-2 md:px-3 lg:px-6 border-r-2  pb-2" : "inline-block text-lg text-ato-ash-2 border-ato-form-border px-2 sm:px-2 md:px-3 lg:px-6 block border-r-2 font-extralight pb-2"
              }
              onClick={() => SelectTab(0)}
            >
              <div style={{cursor: 'pointer'}}>Artworks</div>
            </h3>
            
            <h3 className={
              selectedTab === 1 ? "inline-block text-ato-red font-millerBanner pr-2 sm:pr-2 md:pr-3 lg:pr-6 border-r-2  pb-2" : "inline-block text-lg text-ato-ash-2 border-ato-form-border block font-extralight pr-2 sm:pr-2 md:pr-3 lg:pr-6 border-r-2  pb-2"
              }
              onClick={() => SelectTab(1)}
            >
              <div style={{cursor: 'pointer'}}>Biography</div>
            </h3>
            <h3 className={
              selectedTab === 2 ? "inline-block text-ato-red font-millerBanner pr-2 sm:pr-2 md:pr-3 lg:pr-6 border-r-2  pb-2" : "inline-block text-lg text-ato-ash-2 border-ato-form-border block font-extralight pr-2 sm:pr-2 md:pr-3 lg:pr-6 border-r-2  pb-2"
              }
              onClick={() => SelectTab(2)}
            >
              <div style={{cursor: 'pointer'}}>Exhibition</div>
            </h3>
            <h3 className={
              selectedTab === 3 ? "inline-block text-ato-red font-millerBanner pr-2 sm:pr-2 md:pr-3 lg:pr-6 border-r-2  pb-2" : "inline-block text-lg text-ato-ash-2 border-ato-form-border block font-extralight pr-2 sm:pr-2 md:pr-3 lg:pr-6 border-r-2  pb-2"
              }
              onClick={() => SelectTab(3)}
            >
              <div style={{cursor: 'pointer'}}>Press</div>
            </h3>
            <h3 className={
              selectedTab === 4 ? "inline-block text-ato-red font-millerBanner  pb-2" : "inline-block text-lg text-ato-ash-2 border-ato-form-border  block font-extralight  pb-2"
              }
              onClick={() => SelectTab(4)}
            >
              <div style={{cursor: 'pointer'}}>Contact</div>
            </h3>
          </div>

          {selectedTab === 0 &&
            <div className='w-full'>
              <Swiper
                  grabCursor={true}
                  spaceBetween={2}
                  slidesPerView={5}
                  navigation={{
                      nextEl: '.swiper-button-next',
                      prevEl: '.swiper-button-prev',
                  }}
                  modules={[Navigation, A11y]}
                  onSwiper={(swiper) => {
                  // console.log(swiper);
                  }}
                  onSlideChange={() => {
                  // console.log('slide change')
                  }}
                  breakpoints={{
                  // when window width is >= 320px
                  320: {
                      slidesPerView: 1,
                      spaceBetween: 5,
                  },
                  // when window width is >= 480px
                  480: {
                      slidesPerView: 1,
                      spaceBetween: 15,
                  },
                  // when window width is >= 640px
                  640: {
                      slidesPerView: 2,
                      spaceBetween: 10,
                  },

                  1024: {
                      slidesPerView: 4,
                      spaceBetween: 25,
                  },

                  1280: {
                      slidesPerView: 4,
                      spaceBetween: 30,
                  },

                  1440: {
                      slidesPerView: 5,
                      spaceBetween: 30,
                  },

                  1680: {
                      slidesPerView: 6,
                      spaceBetween: 35,
                  },
                  }}
                  >
                  {artworks && artworks.length > 0 && artworks.map((artwork) => {                
                      return (
                          <SwiperSlide key={artwork._id}>
                              <div className="flex flex-col gap-4 p-4 w-[210px]">
                                  <Link to={`/artwork/detail/${artwork._id}/${getArtworkQuery(artwork, user)}`}>
                                      <div style={{width: '210px', height: '210px', display :'flex'}}>
                                          <img src={artwork.images.length > 0 ? getResolvedPath(artwork.images[0]): ''} style={{objectFit: 'cover', display: 'block', width: '210px', maxHeight: '210px', marginTop: 'auto'}} alt=""/>
                                      </div>
                                  </Link>
                                  <Link to={`/artwork/detail/${artwork._id}/${getArtworkQuery(artwork, user)}`}>
                                      <span className='font-semibold text-gray-900'>{artwork.name}</span>
                                  </Link>
                                  <span className='text-gray-400'>{user.firstname} {user.lastname}</span>
                                  <span className='MillerBanner font-millerBanner text-lg text-ato-red font-semibold'>$ {artwork.listed_price}</span>
                                  <div className='flex flex-row'>
                                      <Link to={`/artwork/detail/${artwork._id}/${getArtworkQuery(artwork, user)}`}>
                                          <div className="flex mt-4">
                                              <span className="hidden md:block text-gray-600  text-sm md:text-md lg:text-lg ">
                                              View
                                              </span>
                                              <span className="flex self-center px-1">
                                              <svg
                                                  width="20"
                                                  height="12"
                                                  viewBox="0 0 24 16"
                                                  fill="none"
                                                  xmlns="http://www.w3.org/2000/svg">
                                                  <path
                                                  d="M11.9999 15.924C14.6912 15.924 17.5555 14.6894 20.3209 12.3684C22.3703 10.6152 23.6297 8.91169 23.679 8.83744L24 8.39308L23.679 7.94872C23.6297 7.87449 22.3703 6.17093 20.3209 4.4424C17.5555 2.09676 14.6913 0.862183 11.9999 0.862183C9.30853 0.862183 6.44432 2.09676 3.67888 4.4178C1.62949 6.14616 0.370264 7.87451 0.320837 7.94859L-0.000204086 8.39295L0.320837 8.8373C0.370098 8.91171 1.62949 10.6153 3.67888 12.3438C6.44428 14.6894 9.30853 15.924 11.9999 15.924ZM22.1481 8.39312C20.9629 9.84987 16.79 14.4425 11.9999 14.4425C7.20975 14.4425 3.06159 9.84992 1.85171 8.39312C3.06164 6.93637 7.20975 2.34371 11.9999 2.34371C16.79 2.34371 20.9382 6.93633 22.1481 8.39312Z"
                                                  fill="#75757B"
                                                  />
                                                  <path
                                                  d="M11.9998 13.4302C14.7652 13.4302 17.0369 11.1832 17.0369 8.39311C17.0369 5.62771 14.7653 3.35605 11.9998 3.35605C9.23436 3.35605 6.96275 5.62766 6.96275 8.39311C6.96275 11.1586 9.23436 13.4302 11.9998 13.4302ZM11.9998 4.83754C13.9503 4.83754 15.5554 6.44239 15.5554 8.39315C15.5554 10.3437 13.9504 11.9488 11.9998 11.9488C10.0492 11.9488 8.44419 10.3437 8.44419 8.39315C8.44419 6.44257 10.0492 4.83754 11.9998 4.83754Z"
                                                  fill="#75757B"
                                                  />
                                              </svg>
                                              </span>
                                          </div>
                                      </Link>
                                      {artwork.verified && <Link to={`/artwork/scan/${artwork._id}/${getArtworkQuery(artwork, user)}`}>
                                          <div className="flex mt-4 ml-4">
                                              <span className="hidden md:block text-gray-600  text-sm md:text-md lg:text-lg ">
                                              Scan
                                              </span>
                                              <span className="flex self-center px-1">
                                              <svg 
                                                  xmlns="http://www.w3.org/2000/svg" 
                                                  className="h-4 w-4" 
                                                  fill="none" 
                                                  viewBox="0 0 24 24" 
                                                  stroke="currentColor" 
                                                  strokeWidth="1">
                                                  <path 
                                                      strokeLinecap="round" 
                                                      strokeLinejoin="round" 
                                                      d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                                              </svg>
                                              </span>
                                          </div>
                                      </Link>}
                                  </div>
                              </div>
                          </SwiperSlide>
                      )
                  })}
                  <div className="swiper-button-next !w-20 md:!w-52 lg:!w-80 after:text-ato-upload-text"></div>
                  <div className="swiper-button-prev !w-20 md:!w-50 lg:!w-80 after:text-ato-upload-text"></div>
              </Swiper>   
            </div>
          }
          {selectedTab === 1 &&
            <div className='w-full flex flex-col mt-[2rem]'>
              <div className="text-md text-ato-black mt-6" style={{whiteSpace: "pre-wrap"}}>
                {biography}
              </div>
            </div>
          }
          {selectedTab === 2 &&
            <div className='w-full flex flex-col mt-[2rem]'>
              <div className="text-md text-ato-black mt-6" style={{whiteSpace: "pre-wrap"}}>
                {exhibition}
              </div>
            </div>
          }
          {selectedTab === 3 &&
            <div className='w-full flex flex-col mt-[2rem]'>
              <div className="text-md text-ato-black mt-6" style={{whiteSpace: "pre-wrap"}}>
                {extractUrlFromString(appearance).map((oneUrl, key) =><a href = {oneUrl} key = {key} target="_blank" className='hover:text-red-500'>{oneUrl}</a> )}
              </div>
            </div>
          }
          {selectedTab === 4 &&
            <div className='w-full flex flex-col mt-[2rem]'>
              {user.contact_email && <>
              <span className="text-md text-ato-red mt-3 font-semibold">
                Contact Email: 
              </span>
              <div className="text-md text-ato-black mt-6" style={{whiteSpace: "pre-wrap"}}>
                {user.contact_email}
              </div></>}
              {user.gallery_email && <>
              <span className="text-md text-ato-red mt-3 font-semibold">
                Gallery Emails: 
              </span>
              <div className="text-md text-ato-black mt-6" style={{whiteSpace: "pre-wrap"}}>
                {user.gallery_email}
              </div></>}
            </div>
          }
          <div className="flex flex-col md:flex-row gap-y-5 justify-center items-center md:gap-x-5 lg:gap-x-10 py-8 md:pb-20 mt-6">
              <button
                  type="button"
                  className="w-56 py-1 px-5 lg:py-1 lg:px-4 flex justify-center items-center  bg-ato-form-border text-ato-form-text hover:bg-ato-form-text hover:text-ato-form-border focus:ring-gray-200 focus:ring-offset-gray-200 transition ease-in duration-100 text-center text-base md:text-base font-millerBanner shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2"
                  onClick={(e) => navigate(-1)}
              >
                  {`< Back`} 
                  &nbsp;<FontAwesomeIcon icon={faArrowLeft} />
              </button>
          </div> 
        </div>
        {/* <div className="w-full border-2 border-ato-form-border py-5 px-3 md:pb-16">
            <div className='grid grid-cols-1 gap-10 md:grid-cols-1 md:px-5 xl:px-10 w-full divide-x-0 md:divide-x'>

            <div className="flex flex-col md:pl-8 gap-4 -mt-4 md:mt-0">
                <div className="flex flex-col">
                <span className="font-millerBanner text-lg text-ato-red font-semibold">
                    Photo
                </span>
                <div className="w-full flex flex-col text-ato-form-text text-sm  justify-center px-3 py-2 font-universLight ">
                    <div>
                        <div 
                            className="relative cursor-pointer"
                        >
                            <img src={photo} alt="photo" className='w-[250px] h-[250px] rounded-full m-auto'/>
                        </div>
                    </div>
                </div>
                </div>
                <div className="flex-col gap-3 font-universLight flex">
                <span className="font-millerBanner text-lg text-ato-red font-semibold">
                    Information
                </span>
                <div className='flex flex-row gap-5'>
                    <div className="flex flex-col w-1/2 gap-2">
                    <span className="text-sm text-ato-black">
                        First Name
                    </span>
                    <div className="w-full h-8 md:h-10 relative text-ato-form-text text-sm">
                        <input
                        type="text"
                        className=" py-2.5 md:pr-1 lg:pr-3 pl-5  w-full h-full ring-1 ring-ato-title focus:ring-gray-500 block  outline-none caret-ato-red"
                        placeholder="First Name"
                        name='firstname'
                        value={firstname}
                        readOnly={true}
                        />
                    </div>
                    </div>
                    <div className="flex flex-col w-1/2 gap-2">
                    <span className="text-sm text-ato-black">
                        Last Name
                    </span>
                    <div className="w-full h-8 md:h-10 relative text-ato-form-text text-sm">
                        <input
                        type="text"
                        className=" py-2.5 md:pr-1 lg:pr-3 pl-5  w-full h-full ring-1 ring-ato-title focus:ring-gray-500 block  outline-none caret-ato-red"
                        placeholder="Last Name"
                        name='lastname'
                        value={lastname}
                        readOnly={true}
                        />
                    </div>
                    </div>
                </div>
                <div className="flex flex-col w-full gap-2">
                    <span className="text-sm text-ato-black">
                    Birthday
                    </span>
                    <div className="w-full relative text-ato-form-text text-sm">
                    <textarea
                        type="text"
                        className=" p-2.5  resize-none ring-1 ring-ato-title text-sm focus:ring-gray-500 block outline-none caret-ato-red w-full"
                        placeholder="e.g. 07-28-1990"
                        name='birth'
                        value={birth}
                        readOnly={true}
                    />
                    </div>
                </div>
                <div className="flex flex-col w-full gap-2">
                    <span className="text-sm text-ato-black">
                    Biography
                    </span>
                    <div className="w-full relative text-ato-form-text text-sm">
                    <textarea
                        type="text"
                        className=" p-2.5  resize-none ring-1 ring-ato-title text-sm focus:ring-gray-500 block outline-none caret-ato-red w-full"
                        placeholder="Biography"
                        name='biography'
                        value={biography}
                        readOnly={true}
                    />
                    </div>
                </div>
                <div className="flex flex-col w-full gap-2">
                  <span className="text-sm text-ato-black">
                    Nationality
                  </span>
                  <div className="w-full relative text-ato-form-text text-sm">
                    <Select 
                      defaultValue={defaultNationality}
                      value={defaultNationality}
                      isDisabled={true}
                      options={optionsForNationalities} 
                      className="w-full h-full text-sm" 
                      name="nationality"
                    />
                  </div>
                </div>
                <div className="flex flex-col w-full gap-2">
                    <span className="text-sm text-ato-black">
                    Educations
                    </span>
                    <div className="w-full relative text-ato-form-text text-sm">
                    <textarea
                        type="text"
                        className=" p-2.5  resize-none ring-1 ring-ato-title text-sm focus:ring-gray-500 block outline-none caret-ato-red w-full"
                        placeholder="Educations"
                        name='education'
                        value={education}
                        readOnly={true}
                    />
                    </div>
                </div>
                <div className="flex flex-col w-full gap-2">
                    <span className="text-sm text-ato-black">
                    Publications about artist
                    </span>
                    <div className="w-full relative text-ato-form-text text-sm">
                    <textarea
                        type="text"
                        className=" p-2.5  resize-none ring-1 ring-ato-title text-sm focus:ring-gray-500 block outline-none caret-ato-red w-full"
                        placeholder="Publications about artist"
                        name='publication'
                        value={publication}
                        readOnly={true}
                    />
                    </div>
                </div>
                <div className="flex flex-col w-full gap-2">
                    <span className="text-sm text-ato-black">
                    Teaching Experience location and date
                    </span>
                    <div className="w-full relative text-ato-form-text text-sm">
                    <textarea
                        type="text"
                        className=" p-2.5  resize-none ring-1 ring-ato-title text-sm focus:ring-gray-500 block outline-none caret-ato-red w-full"
                        placeholder="Teaching Experience location and date"
                        name='teaching'
                        value={teaching}
                        readOnly={true}
                    />
                    </div>
                </div>
                <div className="flex flex-col w-full gap-2">
                    <span className="text-sm text-ato-black">
                    Publications written by artist
                    </span>
                    <div className="w-full relative text-ato-form-text text-sm">
                    <textarea
                        type="text"
                        className=" p-2.5  resize-none ring-1 ring-ato-title text-sm focus:ring-gray-500 block outline-none caret-ato-red w-full"
                        placeholder="Publications written by artist"
                        name='writing'
                        value={writing}
                        readOnly={true}
                    />
                    </div>
                </div>
                <div className="flex flex-col w-full gap-2">
                    <span className="text-sm text-ato-black">
                    Artist curated shows
                    </span>
                    <div className="w-full relative text-ato-form-text text-sm">
                    <textarea
                        type="text"
                        className=" p-2.5  resize-none ring-1 ring-ato-title text-sm focus:ring-gray-500 block outline-none caret-ato-red w-full"
                        placeholder="Artist curated shows"
                        name='curating'
                        value={curating}
                        readOnly={true}
                    />
                    </div>
                </div>
                <div className="flex flex-col w-full gap-2">
                    <span className="text-sm text-ato-black">
                    Public Collections
                    </span>
                    <div className="w-full relative text-ato-form-text text-sm">
                    <textarea
                        type="text"
                        className=" p-2.5  resize-none ring-1 ring-ato-title text-sm focus:ring-gray-500 block outline-none caret-ato-red w-full"
                        placeholder="Public Collections"
                        name='public'
                        value={publics}
                        readOnly={true}
                    />
                    </div>
                </div>
                <div className="flex flex-col w-full gap-2">
                    <span className="text-sm text-ato-black">
                    Private Collections available for public knowledge
                    </span>
                    <div className="w-full relative text-ato-form-text text-sm">
                    <textarea
                        type="text"
                        className=" p-2.5  resize-none ring-1 ring-ato-title text-sm focus:ring-gray-500 block outline-none caret-ato-red w-full"
                        placeholder="Private Collections available for public knowledge"
                        name='private'
                        value={privates}
                        readOnly={true}
                    />
                    </div>
                </div>
                <div className="flex flex-col w-full gap-2">
                    <span className="text-sm text-ato-black">
                    Exhibitions
                    </span>
                    <div className="w-full relative text-ato-form-text text-sm">
                    <textarea
                        type="text"
                        className=" p-2.5  resize-none ring-1 ring-ato-title text-sm focus:ring-gray-500 block outline-none caret-ato-red w-full"
                        placeholder="Exhibitions"
                        name='exhibition'
                        value={exhibition}
                        readOnly={true}
                    />
                    </div>
                </div>
                <div className="flex flex-col w-full gap-2">
                    <span className="text-sm text-ato-black">
                    Appearance in press or social media
                    </span>
                    <div className="w-full relative text-ato-form-text text-sm">
                    <textarea
                        type="text"
                        className=" p-2.5  resize-none ring-1 ring-ato-title text-sm focus:ring-gray-500 block outline-none caret-ato-red w-full"
                        placeholder="Appearance in press or social media"
                        name='appearance'
                        value={appearance}
                        readOnly={true}
                    />
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        <div className="flex flex-col md:flex-row gap-y-5 justify-center items-center md:gap-x-5 lg:gap-x-10 py-8 md:pb-20">
            <button
                type="button"
                className="w-56 py-1 px-5 lg:py-1 lg:px-4 flex justify-center items-center  bg-ato-form-border text-ato-form-text hover:bg-ato-form-text hover:text-ato-form-border focus:ring-gray-200 focus:ring-offset-gray-200 transition ease-in duration-100 text-center text-base md:text-base font-millerBanner shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2"
                onClick={(e) => navigate(-1)}
            >
                {`< Back`} 
                &nbsp;<FontAwesomeIcon icon={faArrowLeft} />
            </button>
        </div> */}
        </>
      }
    </Layout>
  );
}

export default UserProfile_Detail;